import React from 'react';

import SearchIcon from '@atlaskit/icon/glyph/search';

import { ContainerStyled } from './InputSearchIcon.styled';

export function InputSearchIcon(): JSX.Element {
  return (
    <ContainerStyled>
      <SearchIcon
        testId='search-icon'
        primaryColor='var(--ds-icon-subtle, var(--ds-fb-icon-subtle))'
        label=''
      />
    </ContainerStyled>
  );
}
